<script>
  // @ts-check
  import { EPL_FORM_FACTORS } from "$lib/utilities/contentTypes/eventPreviewList";

  import {
    EventGrid,
    ScheduleCardList,
    Section,
    ListThumbnail,
    SplitLayout,
    DynamicHeading
  } from "@ObamaFoundation/of-design-system";
  import EventThumbnailContent from "$lib/components/EventThumbnailContent.svelte";

  export let id;
  /** @type { string } */
  let className = "";
  export { className as class };
  export let title = "Schedule";
  export let items = [];
  export let featuredItems = [];
  export let days = [];
  export let formFactor = "Calendar Grid";
  export let isToursEPL = false;

  const hasFeaturedItem = featuredItems.length > 0;
</script>

<div class="{className} epl" {id}>
  {#if formFactor === EPL_FORM_FACTORS.GRID}
    <EventGrid items={[...featuredItems, ...items]} {hasFeaturedItem} />
  {:else if formFactor === EPL_FORM_FACTORS.LIST}
    <Section>
      <SplitLayout variant="25/50" id="epl-list-{id}" isSticky={false}>
        <div slot="left" class="pb-4">
          <DynamicHeading class="heading-sm">{title}</DynamicHeading>
        </div>
        <ListThumbnail
          slot="right"
          data={[...featuredItems, ...items].map((item) => {
            return {
              headline: item.eventTitle,
              image: item.image,
              component: EventThumbnailContent,
              componentProps: {
                subtitle: item.eventDate,
                description: item.description,
                cta: item.cta
              }
            };
          })}
        />
      </SplitLayout>
    </Section>
  {:else if formFactor === EPL_FORM_FACTORS.SCHEDULE}
    <ScheduleCardList
      {days}
      emptyStateMessage={isToursEPL ? "No Tours remaining" : "No events remaining"}
    />
  {/if}
</div>
